import { gql, useMutation } from "@apollo/client";
import type { AssetImage, MultilingualInput } from "gql/generated";

const ImageFragmentWithMux = gql`
  fragment ImageFragmentWithMux on AssetImage {
    _id
    type
    blurhash
    caption {
      en
      es
      fr
    }
    width
    height
    isVideo
    format
    qualityScore
    bytes
    hasTransparency
    lightness
    mux {
      assetId
      playbackId
      status
    }
  }
`;

const VideoCreateFromMuxDocument = gql`
  mutation VideoCreateFromMux(
    $muxAssetId: String!
    $muxPlaybackId: String
    $muxStatus: String
    $width: Int
    $height: Int
    $duration: Float
    $bytes: Float
    $defaultCaption: MultilingualInput
  ) {
    videoCreateFromMux(
      muxAssetId: $muxAssetId
      muxPlaybackId: $muxPlaybackId
      muxStatus: $muxStatus
      width: $width
      height: $height
      duration: $duration
      bytes: $bytes
      defaultCaption: $defaultCaption
    ) {
      ...ImageFragmentWithMux
    }
  }
  ${ImageFragmentWithMux}
`;

const VideoMuxStatusRefreshDocument = gql`
  mutation VideoMuxStatusRefresh($_id: String!) {
    videoMuxStatusRefresh(_id: $_id) {
      ...ImageFragmentWithMux
    }
  }
  ${ImageFragmentWithMux}
`;

const VideoDeleteFromMuxOnlyDocument = gql`
  mutation VideoDeleteFromMuxOnly($muxAssetId: String!) {
    videoDeleteFromMuxOnly(muxAssetId: $muxAssetId)
  }
`;

export type VideoCreateFromMuxVariables = {
  muxAssetId: string;
  muxPlaybackId?: string | null;
  muxStatus?: string | null;
  width?: number | null;
  height?: number | null;
  duration?: number | null;
  bytes?: number | null;
  defaultCaption?: MultilingualInput | null;
};

export function useVideoCreateFromMuxMutation() {
  return useMutation<
    { videoCreateFromMux: AssetImage },
    VideoCreateFromMuxVariables
  >(VideoCreateFromMuxDocument);
}

export function useVideoMuxStatusRefreshMutation() {
  return useMutation<
    { videoMuxStatusRefresh: AssetImage },
    { _id: string }
  >(VideoMuxStatusRefreshDocument);
}

export function useVideoDeleteFromMuxOnlyMutation() {
  return useMutation<
    { videoDeleteFromMuxOnly: boolean },
    { muxAssetId: string }
  >(VideoDeleteFromMuxOnlyDocument);
}
